module.exports = __webpack_public_path__ + "data/app.menu.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/menu/app.menu.json
// module id = i017
// module chunks = 1